/* MTL Product Quiz v1. Config: snippets/mtl-quiz-config.liquid. Plan: handoffs/HANDOFF-product-quiz-v1-build.md */
(function () {
  'use strict';

  var root = document.querySelector('[data-mtl-quiz]');
  var cfgEl = document.getElementById('mtl-quiz-config');
  if (!root || !cfgEl) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[mtl-quiz] config JSON is invalid', e); return; }

  var STATE_KEY = 'mtl_quiz_state_v1';
  var CAPTURED_KEY = 'mtl_quiz_email_captured';
  var RESUME_MS = 60 * 60 * 1000;
  var params = new URLSearchParams(window.location.search);
  var forceGate = params.get('quiz_force_gate') === '1';
  var liquidSubscribed = root.getAttribute('data-subscribed') === 'true';

  var stageEl = root.querySelector('[data-quiz-stage]');
  var progressEl = root.querySelector('[data-quiz-progress]');
  var progressWrap = progressEl ? progressEl.parentNode : null;
  var backBtn = root.querySelector('[data-quiz-back]');
  var customerForm = document.getElementById('mtl-quiz-customer-form');

  var state = freshState();

  /* ---------- storage (every access guarded: private windows and blocked storage throw) ---------- */
  function store(kind) { try { return window[kind]; } catch (e) { return null; } }
  function sGet(kind, key) { try { var s = store(kind); return s ? s.getItem(key) : null; } catch (e) { return null; } }
  function sSet(kind, key, val) { try { var s = store(kind); if (s) s.setItem(key, val); } catch (e) {} }
  function sDel(kind, key) { try { var s = store(kind); if (s) s.removeItem(key); } catch (e) {} }

  function freshState() {
    return { screen: 'Q0', history: [], answers: {}, entry: null, pillar: null, freeText: '', stage: 'questions', resultsTracked: false, ts: Date.now() };
  }
  function save() { state.ts = Date.now(); sSet('sessionStorage', STATE_KEY, JSON.stringify(state)); }
  function load() {
    var raw = sGet('sessionStorage', STATE_KEY);
    if (!raw) return null;
    try {
      var s = JSON.parse(raw);
      if (!s || !s.ts || Date.now() - s.ts > RESUME_MS || !CFG.screens[s.screen]) return null;
      return s;
    } catch (e) { return null; }
  }

  /* ---------- small DOM helpers (textContent only, so free text can never inject markup) ---------- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function checkIcon() {
    var span = el('span', 'mtl-quiz__check');
    span.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M2.5 6.2l2.3 2.3 4.7-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return span;
  }
  function mount(node) {
    stageEl.innerHTML = '';
    stageEl.appendChild(node);
    var focusTarget = node.querySelector('[data-quiz-focus]');
    if (focusTarget) { focusTarget.setAttribute('tabindex', '-1'); try { focusTarget.focus({ preventScroll: true }); } catch (e) {} }
    var top = root.getBoundingClientRect().top;
    if (top < 0) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function setProgress(pct) {
    var v = Math.max(0, Math.min(100, Math.round(pct)));
    if (progressEl) progressEl.style.width = v + '%';
    if (progressWrap) progressWrap.setAttribute('aria-valuenow', String(v));
  }
  function money(n) { return '$' + Math.round(n).toLocaleString('en-US'); }
  function sized(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* ---------- question screens ---------- */
  function renderScreen(id) {
    var sc = CFG.screens[id];
    if (!sc) return;
    state.screen = id;
    state.stage = 'questions';
    save();
    if (sc.type === 'gate') return renderGate(sc);

    var done = state.history.length;
    setProgress(done / (done + (sc.remaining || 1)) * 100);
    backBtn.hidden = state.history.length === 0;

    var wrap = el('div', 'mtl-quiz__screen');
    if (id === 'Q0' && CFG.eyebrow) {
      wrap.appendChild(el('span', 'mtl-quiz__eyebrow', CFG.eyebrow));
      wrap.appendChild(el('span', 'mtl-quiz__rule'));
    }
    var h = el('h1', 'mtl-quiz__lead', sc.lead);
    h.setAttribute('data-quiz-focus', '');
    wrap.appendChild(h);
    if (sc.sub) wrap.appendChild(el('p', 'mtl-quiz__sub', sc.sub));

    var list = el('div', 'mtl-quiz__options');
    list.setAttribute('role', 'group');
    var prior = state.answers[id];
    var picked = sc.type === 'multi' ? (Array.isArray(prior) ? prior.slice() : []) : null;
    var continueBtn;

    optionsFor(sc).forEach(function (opt) {
      var b = el('button', 'mtl-quiz__option');
      b.type = 'button';
      if (sc.type === 'multi') b.appendChild(checkIcon());
      b.appendChild(el('span', null, opt.label));
      var on = sc.type === 'multi' ? picked.indexOf(opt.id) !== -1 : prior === opt.id;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.addEventListener('click', function () {
        if (sc.type === 'multi') {
          var i = picked.indexOf(opt.id);
          if (i === -1) picked.push(opt.id); else picked.splice(i, 1);
          b.setAttribute('aria-pressed', i === -1 ? 'true' : 'false');
          continueBtn.disabled = picked.length === 0;
        } else {
          b.setAttribute('aria-pressed', 'true');
          answer(id, opt.id, opt.next || sc.next, opt.pillar);
        }
      });
      list.appendChild(b);
    });
    wrap.appendChild(list);

    if (sc.type === 'multi') {
      continueBtn = el('button', 'mtl-quiz__btn mtl-quiz__btn--block', sc.button || 'Continue');
      continueBtn.type = 'button';
      continueBtn.disabled = picked.length === 0;
      continueBtn.addEventListener('click', function () {
        if (picked.length) answer(id, picked.slice(), sc.next, null);
      });
      wrap.appendChild(continueBtn);
    }

    if (sc.free_text) wrap.appendChild(freeTextBlock(id, sc.free_text));
    mount(wrap);
  }

  /* A screen can swap its options per pillar (the investment bands differ for performance). */
  function optionsFor(sc) {
    return (sc.options_by_pillar && state.pillar && sc.options_by_pillar[state.pillar]) || sc.options || [];
  }

  function freeTextBlock(id, ft) {
    var box = el('form', 'mtl-quiz__free');
    box.setAttribute('novalidate', '');
    var inputId = 'mtl-quiz-free-' + id;
    var lab = el('label', null, ft.label);
    lab.setAttribute('for', inputId);
    var row = el('div', 'mtl-quiz__row');
    var input = el('input', 'mtl-quiz__input');
    input.type = 'text';
    input.id = inputId;
    input.maxLength = 300;
    input.value = state.freeText || '';
    var go = el('button', 'mtl-quiz__btn', ft.button || 'Continue');
    go.type = 'submit';
    row.appendChild(input);
    row.appendChild(go);
    box.appendChild(lab);
    box.appendChild(row);
    box.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var text = input.value.trim();
      if (!text) { input.focus(); return; }
      state.freeText = text;
      var bucket = classify(text);
      var route = bucket ? CFG.free_text_routes[bucket] : null;
      state.entry = 'free_text';
      if (route) answer(id, 'free_text:' + bucket, route.next, route.pillar);
      else answer(id, 'free_text:unmatched', 'Q0b', null);
    });
    return box;
  }

  /* Keyword routing. Keywords are whole words; a trailing * allows endings (sore* = sore, soreness).
     "strong" words name the problem, "weak" words are context (gym, back, night).
     Rules, in order: strong hits in TWO pillars -> Q0b (never guess between pillars);
     strong hits in exactly one pillar -> that pillar; strong "drained" -> Q0a;
     otherwise the single highest context score wins, a pillar beats "drained" on a tie, any other tie -> Q0b. */
  var PILLAR_BUCKETS = ['sleep', 'sore', 'winded'];
  function kwRegex(kw) {
    var esc = kw.replace(/[.+?^${}()|[\]\\]/g, '\\$&');
    if (esc.slice(-1) === '*') esc = esc.slice(0, -1) + "[a-z']*";
    return new RegExp('(^|[^a-z0-9])' + esc + '(?=$|[^a-z0-9])');
  }
  function countHits(t, list) {
    var n = 0;
    (list || []).forEach(function (kw) { if (kwRegex(kw).test(t)) n++; });
    return n;
  }
  function classify(text) {
    var t = text.toLowerCase().replace(/[‘’]/g, "'").replace(/\s+/g, ' ');
    (CFG.free_text_negations || []).forEach(function (neg) { t = t.split(neg).join(' '); });
    var strong = {};
    var score = {};
    Object.keys(CFG.free_text_keywords).forEach(function (b) {
      var k = CFG.free_text_keywords[b];
      strong[b] = countHits(t, k.strong);
      score[b] = strong[b] * 2 + countHits(t, k.weak);
    });
    var strongPillars = PILLAR_BUCKETS.filter(function (b) { return strong[b] > 0; });
    if (strongPillars.length > 1) return null;
    if (strongPillars.length === 1) return strongPillars[0];
    if (strong.drained > 0) return 'drained';
    var best = 0;
    Object.keys(score).forEach(function (b) { if (score[b] > best) best = score[b]; });
    if (!best) return null;
    var tops = Object.keys(score).filter(function (b) { return score[b] === best; });
    if (tops.length === 1) return tops[0];
    var pillarTops = tops.filter(function (b) { return PILLAR_BUCKETS.indexOf(b) !== -1; });
    if (pillarTops.length === 1 && tops.length === 2) return pillarTops[0];
    return null;
  }

  function answer(screenId, value, next, pillar) {
    state.answers[screenId] = value;
    if (screenId === 'Q0' && typeof value === 'string' && value.indexOf('free_text') !== 0) {
      state.entry = value;
      state.freeText = '';
    }
    if (pillar) state.pillar = pillar;
    state.history.push(screenId);
    if (next === 'GATE') return toGateOrResults();
    window.setTimeout(function () { renderScreen(next); }, 140);
  }

  function goBack() {
    if (!state.history.length) return;
    var prev = state.history.pop();
    state.pillar = pillarFromHistory();
    renderScreen(prev);
  }
  function pillarFromHistory() {
    var p = null;
    state.history.forEach(function (sid) {
      var sc = CFG.screens[sid];
      var v = state.answers[sid];
      if (!sc || typeof v !== 'string') return;
      if (v.indexOf('free_text:') === 0) {
        var r = CFG.free_text_routes[v.split(':')[1]];
        if (r && r.pillar) p = r.pillar;
        return;
      }
      (sc.options || []).forEach(function (o) { if (o.id === v && o.pillar) p = o.pillar; });
    });
    return p;
  }

  /* ---------- answers on the path actually taken (a back-and-switch must not leak the other branch) ---------- */
  function pathAnswers() {
    var a = {};
    state.history.forEach(function (sid) { if (sid in state.answers) a[sid] = state.answers[sid]; });
    return a;
  }

  function matchRoute() {
    var a = pathAnswers();
    for (var i = 0; i < CFG.routes.length; i++) {
      var r = CFG.routes[i];
      if (r.pillar && r.pillar !== state.pillar) continue;
      var ok = true;
      var when = r.when || {};
      Object.keys(when).forEach(function (sid) { if (when[sid].indexOf(a[sid]) === -1) ok = false; });
      if (ok) return r;
    }
    return CFG.fallback_route;
  }

  function buildProps(route) {
    var a = pathAnswers();
    var pain = null;
    ['R3', 'P2', 'S2'].forEach(function (sid) { if (a[sid]) pain = a[sid]; });
    var props = {
      quiz_version: CFG.version,
      quiz_entry_symptom: state.entry || null,
      quiz_free_text: state.freeText ? state.freeText.slice(0, 300) : null,
      quiz_pillar: state.pillar || null,
      quiz_specific_pain: pain,
      quiz_recovery_now: a.R1 || null,
      quiz_has_space: a.R2 || null,
      quiz_activities: a.P1 || null,
      quiz_training_setting: a.P3 || null,
      quiz_sleep_hours: a.S1 || null,
      quiz_sleep_setup: a.S3 || null,
      quiz_investment_tier: a.INV || null,
      quiz_outcome_type: route.type,
      quiz_route: route.id,
      quiz_result_collection: route.primary || route.secondary || null,
      quiz_referral: (pickReferral(route) || {}).id || null,
      quiz_heat_cold: a.R4 || null,
      quiz_placement: a.R5 || null,
      quiz_scope: a.R3S || null,
      quiz_completed_at: new Date().toISOString()
    };
    Object.keys(props).forEach(function (k) { if (props[k] == null) delete props[k]; });
    return props;
  }

  function buildTags(props) {
    var tags = ['quiz'];
    [['quiz_pillar', 'quiz_pillar'], ['quiz_specific_pain', 'quiz_specific_pain'], ['quiz_investment_tier', 'quiz_investment_tier'],
     ['quiz_outcome_type', 'quiz_outcome_type'], ['quiz_entry_symptom', 'quiz_entry_symptom']].forEach(function (p) {
      if (props[p[0]]) tags.push(p[1] + ':' + props[p[0]]);
    });
    return tags.join(', ');
  }

  /* ---------- Klaviyo: onsite JS is loaded by the Klaviyo app embed. Works with the object API or the queue. ---------- */
  function klaviyoCall(method, args) {
    try {
      var k = window.klaviyo;
      if (!k) return Promise.resolve(false);
      if (typeof k[method] === 'function') {
        return Promise.resolve(k[method].apply(k, args)).then(function () { return true; }, function () { return false; });
      }
      if (typeof k.push === 'function') { k.push([method].concat(args)); return Promise.resolve(true); }
    } catch (e) {}
    return Promise.resolve(false);
  }
  function klaviyoIdentified() {
    try {
      var k = window.klaviyo;
      if (k && typeof k.isIdentified === 'function') {
        return Promise.resolve(k.isIdentified()).then(Boolean, function () { return false; });
      }
    } catch (e) {}
    return Promise.resolve(false);
  }
  function withTimeout(p, ms, fallback) {
    return new Promise(function (resolve) {
      var done = false;
      var t = window.setTimeout(function () { if (!done) { done = true; resolve(fallback); } }, ms);
      p.then(function (v) { if (!done) { done = true; window.clearTimeout(t); resolve(v); } },
             function () { if (!done) { done = true; window.clearTimeout(t); resolve(fallback); } });
    });
  }
  function writeKlaviyo(email, props) {
    var identity = {};
    Object.keys(props).forEach(function (k) { identity[k] = props[k]; });
    if (email) identity.email = email;
    return klaviyoCall('identify', [identity]).then(function () {
      return klaviyoCall('track', [CFG.klaviyo_event, props]);
    });
  }

  /* ---------- results event: what the buyer actually saw, for the results email ---------- */
  /* The gate event fires before the picks exist, so this second event carries them. Once per completion: the flag
     lives in the saved state, so a reload back into results does not re-fire it, and a restart clears it. */
  var resultCopy = {};
  function absUrl(u) {
    if (!u) return null;
    if (u.indexOf('//') === 0) return 'https:' + u;
    if (u.charAt(0) === '/') return window.location.origin + u;
    return u;
  }
  function trackResults(picks) {
    if (state.resultsTracked || !CFG.klaviyo_results_event) return;
    state.resultsTracked = true;
    save();
    var route = matchRoute();
    var a = pathAnswers();
    var clean = picks.slice(0, 3).map(function (p) {
      return { name: p.name, url: absUrl(p.url), image: absUrl(p.image), price: p.price || null, price_num: p.price_num || null,
        category: p.category || null, own: !!p.own, gold: !!p.gold, why: p.why || null };
    });
    var props = {
      quiz_pillar: state.pillar || null,
      quiz_investment_tier: a.INV || null,
      quiz_outcome_type: route.type,
      quiz_route: route.id,
      quiz_pain: resultCopy.echo || null,
      results_headline: resultCopy.headline || null,
      results_body: resultCopy.body || null,
      picks: clean,
      pick_count: clean.length,
      own_pick_count: clean.filter(function (p) { return p.own; }).length,
      quiz_completed_at: new Date().toISOString()
    };
    var lead = clean.filter(function (p) { return p.gold; })[0] || clean.filter(function (p) { return p.own; })[0];
    if (lead) {
      props.top_pick_name = lead.name;
      props.top_pick_url = lead.url;
      props.top_pick_image = lead.image;
      props.top_pick_price = lead.price;
    }
    Object.keys(props).forEach(function (k) { if (props[k] == null) delete props[k]; });
    klaviyoCall('track', [CFG.klaviyo_results_event, props]);
  }

  /* ---------- gate ---------- */
  function isSubscriber() {
    if (forceGate) return Promise.resolve(false);
    if (liquidSubscribed || sGet('localStorage', CAPTURED_KEY)) return Promise.resolve(true);
    return withTimeout(klaviyoIdentified(), 1200, false);
  }

  function toGateOrResults() {
    setProgress(92);
    isSubscriber().then(function (subscribed) {
      if (subscribed) {
        var route = matchRoute();
        writeKlaviyo(null, buildProps(route));
        showResults();
      } else {
        renderScreen('GATE');
      }
    });
  }

  function renderGate(sc) {
    backBtn.hidden = state.history.length === 0;
    setProgress(95);
    var wrap = el('div', 'mtl-quiz__screen mtl-quiz__gate');
    var h = el('h1', 'mtl-quiz__lead', sc.headline);
    h.setAttribute('data-quiz-focus', '');
    wrap.appendChild(h);

    var form = el('form');
    form.setAttribute('novalidate', '');
    var input = el('input', 'mtl-quiz__input');
    input.type = 'email';
    input.name = 'email';
    input.autocomplete = 'email';
    input.required = true;
    input.placeholder = sc.placeholder || 'Email address';
    input.setAttribute('aria-label', sc.placeholder || 'Email address');
    var err = el('p', 'mtl-quiz__error');
    err.hidden = true;
    err.setAttribute('role', 'alert');
    var btn = el('button', 'mtl-quiz__btn', sc.button);
    btn.type = 'submit';
    form.appendChild(input);
    /* Optional phone for the text and the call. Only offered once an SMS list is configured, because without it
       the number could not carry SMS consent. */
    var phoneInput = null;
    if (CFG.klaviyo_sms_list_id) {
      phoneInput = el('input', 'mtl-quiz__input mtl-quiz__input--phone');
      phoneInput.type = 'tel';
      phoneInput.name = 'phone';
      phoneInput.autocomplete = 'tel';
      phoneInput.placeholder = sc.phone_placeholder || 'Mobile number (optional)';
      phoneInput.setAttribute('aria-label', sc.phone_placeholder || 'Mobile number (optional)');
      form.appendChild(phoneInput);
    }
    form.appendChild(err);
    form.appendChild(btn);
    form.appendChild(el('p', 'mtl-quiz__reassure', sc.reassurance));
    if (phoneInput && sc.sms_consent) {
      var consent = el('p', 'mtl-quiz__consent', sc.sms_consent + ' ');
      (sc.sms_consent_links || []).forEach(function (l, i) {
        if (i) consent.appendChild(document.createTextNode(' & '));
        var a = el('a', null, l.label);
        a.href = l.url;
        a.target = '_blank';
        a.rel = 'noopener';
        consent.appendChild(a);
      });
      form.appendChild(consent);
    }
    wrap.appendChild(form);

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        err.textContent = sc.error;
        err.hidden = false;
        input.focus();
        return;
      }
      var phone = null;
      if (phoneInput && phoneInput.value.trim()) {
        phone = toE164(phoneInput.value);
        if (!phone) {
          err.textContent = sc.phone_error || 'Please enter a valid US mobile number, or leave it blank.';
          err.hidden = false;
          phoneInput.focus();
          return;
        }
      }
      err.hidden = true;
      btn.disabled = true;
      submitGate(email, phone);
    });
    mount(wrap);
    armCaptcha();
  }

  /* Shopify storefront bot protection arms a customer form only after a focusin or change event inside it
     (or via Shopify.captcha.protect). Until armed, its document submit listener calls preventDefault and does
     nothing else, so a hidden form nobody touches silently never submits (found 2026-09-14). Arm it as soon
     as the gate shows, so hCaptcha loads while the visitor types. */
  var captchaState = 'idle';
  var captchaWaiters = [];
  function armCaptcha() {
    if (captchaState !== 'idle' || !customerForm) return;
    var cap = window.Shopify && window.Shopify.captcha;
    if (!cap || typeof cap.protect !== 'function') { captchaState = 'none'; return; }
    captchaState = 'arming';
    try {
      cap.protect(customerForm, function () {
        captchaState = 'armed';
        captchaWaiters.splice(0).forEach(function (fn) { fn(); });
      });
    } catch (e) { captchaState = 'none'; }
  }
  function whenCaptchaReady(fn) {
    armCaptcha();
    if (captchaState === 'armed' || captchaState === 'none') { fn(); return; }
    var done = false;
    var once = function () { if (!done) { done = true; fn(); } };
    captchaWaiters.push(once);
    window.setTimeout(once, 6000);
  }

  function submitGate(email, phone) {
    var route = matchRoute();
    var props = buildProps(route);
    if (phone) props.quiz_phone_given = true;
    state.stage = 'gate_submitted';
    save();
    sSet('localStorage', CAPTURED_KEY, '1');
    var writes = [writeKlaviyo(email, props)];
    if (phone) writes.push(subscribeSms(email, phone));
    withTimeout(Promise.all(writes), 2500, null).then(function () { subscribeShopify(email, props); });
  }

  /* US numbers only (the sending number is US). 10 digits, or 11 starting with 1. Returns E.164 or null. */
  function toE164(raw) {
    var d = String(raw).replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    if (d.length !== 10 || /^[01]/.test(d)) return null;
    return '+1' + d;
  }

  /* SMS consent has to go through Klaviyo's client subscriptions API: an identify with a phone number records no
     consent. keepalive lets the request finish even though the customer form reloads the page right after. */
  function subscribeSms(email, phone) {
    if (!CFG.klaviyo_sms_list_id || !CFG.klaviyo_company_id) return Promise.resolve(false);
    var body = { data: { type: 'subscription', attributes: {
      custom_source: 'Product Quiz',
      profile: { data: { type: 'profile', attributes: {
        email: email,
        phone_number: phone,
        subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }
      } } }
    }, relationships: { list: { data: { type: 'list', id: CFG.klaviyo_sms_list_id } } } } };
    try {
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(CFG.klaviyo_company_id), {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.ok; }, function () { return false; });
    } catch (e) { return Promise.resolve(false); }
  }

  /* Native Shopify customer form: creates the customer with email marketing consent and the quiz tags.
     It MUST be a real submit, never fetch(): Shopify's storefront bot protection (Shopify.captcha) only
     attaches its token on a real submit event, and a background POST gets "400 Missing CAPTCHA token"
     (found 2026-09-14). requestSubmit fires that event. The page reloads and, because state is saved as
     gate_submitted, boots straight into results. If nothing navigates within 8s, show results anyway so
     the visitor is never trapped on the gate. */
  function subscribeShopify(email, props) {
    if (!customerForm) { showResults(); return; }
    var emailField = customerForm.querySelector('[name="contact[email]"]');
    var tagField = customerForm.querySelector('[name="contact[tags]"]');
    if (emailField) emailField.value = email;
    if (tagField) tagField.value = buildTags(props);
    window.setTimeout(function () { if (state.stage === 'gate_submitted') showResults(); }, 20000);
    whenCaptchaReady(function () {
      if (typeof customerForm.requestSubmit === 'function') customerForm.requestSubmit();
      else customerForm.submit();
    });
  }

  /* ---------- results ---------- */
  function sortMode(route, which) {
    var explicit = route[which + '_sort'];
    if (explicit) return explicit;
    var tier = pathAnswers().INV;
    return (tier && CFG.investment_sort[tier]) || 'collection';
  }
  function linkSort(mode) {
    return mode === 'price-ascending' || mode === 'price-descending' ? '?sort_by=' + mode : '';
  }
  function minPrice(p) {
    var m = Infinity;
    (p.variants || []).forEach(function (v) { var n = parseFloat(v.price); if (!isNaN(n) && n < m) m = n; });
    return m;
  }
  function sortProducts(list, mode) {
    var arr = list.slice();
    if (mode === 'price-ascending') arr.sort(function (a, b) { return minPrice(a) - minPrice(b); });
    else if (mode === 'price-descending') arr.sort(function (a, b) { return minPrice(b) - minPrice(a); });
    else if (mode.indexOf('center:') === 0) {
      var c = parseFloat(mode.split(':')[1]);
      arr.sort(function (a, b) { return Math.abs(minPrice(a) - c) - Math.abs(minPrice(b) - c); });
    }
    return arr;
  }
  function fetchCollection(handle) {
    var h = encodeURIComponent(handle);
    var meta = fetch('/collections/' + h + '.json', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; }).then(function (j) { return j && j.collection; }).catch(function () { return null; });
    var prods = fetch('/collections/' + h + '/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; }).then(function (j) { return (j && j.products) || []; }).catch(function () { return []; });
    return Promise.all([meta, prods]).then(function (res) {
      var ex = CFG.exclude_handles || [];
      return { meta: res[0], products: res[1].filter(function (p) { return ex.indexOf(p.handle) === -1; }) };
    });
  }

  function showResults() {
    var route = matchRoute();
    state.stage = 'results';
    save();
    setProgress(100);
    backBtn.hidden = true;

    var R = CFG.results;
    var outcome = route.outcome ? R.outcomes[route.outcome] : null;
    var wrap = el('div', 'mtl-quiz__screen mtl-quiz__results');
    wrap.appendChild(el('span', 'mtl-quiz__eyebrow', R.eyebrow));
    wrap.appendChild(el('span', 'mtl-quiz__rule'));
    var headline = outcome ? outcome.headline : (route.type === 'partial' ? R.partial_headline : R.match_headline);
    var h = el('h1', 'mtl-quiz__lead', headline);
    h.setAttribute('data-quiz-focus', '');
    wrap.appendChild(h);

    var echo = painEcho();
    if (echo) {
      var p = el('p', 'mtl-quiz__echo', R.echo_prefix + ' ');
      p.appendChild(el('q', null, echo));
      wrap.appendChild(p);
    }
    var bodyText = (outcome && outcome.body) || route.reason;
    var bodyP = route.type !== 'gap' ? engineRules() : null;
    if (bodyP) {
      var gA = pathAnswers();
      if (gA.INV === 'show_fits') bodyText = bodyP.neutral_copy;
      else if (bodyP.scope_key && gA[bodyP.scope_key] === 'targeted') bodyText = bodyP.targeted_copy;
      else bodyText = (bodyP.goal_copy || {})[gA[bodyP.goal_key]] || bodyText;
    }
    if (bodyText) wrap.appendChild(el('p', 'mtl-quiz__body', bodyText));
    resultCopy = { headline: headline, body: bodyText || null, echo: echo };
    var tier = pathAnswers().INV;
    if (R.note_pay_over_time && (route.primary || route.secondary) && (CFG.pay_over_time_tiers || []).indexOf(tier) !== -1) {
      wrap.appendChild(el('p', 'mtl-quiz__note', R.note_pay_over_time));
    }

    var engineAll = engineRules();
    var engineP = engineAll && (route.type !== 'gap' || engineAllowsGap(engineAll)) ? engineAll : null;
    var engineOn = !!engineP;
    var primarySlot = el('div');
    var secondarySlot = el('div');
    wrap.appendChild(primarySlot);
    wrap.appendChild(secondarySlot);
    var referral = engineReplacesReferral(engineP) ? null : pickReferral(route);
    if (referral) wrap.appendChild(renderReferral(referral, tier));

    var foot = el('div', 'mtl-quiz__foot');
    var restart = el('button', 'mtl-quiz__link', R.restart);
    restart.type = 'button';
    restart.addEventListener('click', function () {
      state = freshState();
      save();
      renderScreen('Q0');
    });
    foot.appendChild(restart);
    wrap.appendChild(foot);
    mount(wrap);

    if (engineOn) {
      renderEngine(primarySlot, engineP);
    } else if (route.primary) {
      fetchCollection(route.primary).then(function (data) { renderPrimary(primarySlot, route, data); });
    } else {
      trackResults(referral ? (referral.pick ? [referral.pick] : referral.compare).map(function (p) {
        return { name: p.name, url: p.url, image: p.image, own: false, gold: !!referral.pick };
      }) : []);
    }
    if (!engineOn && route.secondary) {
      fetchCollection(route.secondary).then(function (data) { renderSecondary(secondarySlot, route, data); });
    }
  }

  function painEcho() {
    var a = pathAnswers();
    var sid = ['R3', 'P2', 'S2'].filter(function (s) { return a[s]; })[0];
    if (!sid) return null;
    var opt = (CFG.screens[sid].options || []).filter(function (o) { return o.id === a[sid]; })[0];
    return opt ? opt.label : null;
  }

  function renderPrimary(slot, route, data) {
    var R = CFG.results;
    var handle = route.primary;
    var title = (data.meta && data.meta.title) || handle;
    var mode = sortMode(route, 'primary');
    var url = '/collections/' + handle + linkSort(mode);
    var products = sortProducts(data.products, mode);
    var heroSrc = (data.meta && data.meta.image && data.meta.image.src) || (products[0] && products[0].images && products[0].images[0] && products[0].images[0].src);

    var note = edgeNote(data.products);
    if (note) slot.appendChild(el('p', 'mtl-quiz__note', note));
    trackResults(products.slice(0, 3).map(function (p, i) {
      var mp = minPrice(p);
      return { name: p.title, url: '/products/' + p.handle, image: p.images && p.images[0] && sized(p.images[0].src, 600),
        price: isFinite(mp) ? (R.from + ' ' + money(mp)) : null, price_num: isFinite(mp) ? mp : null, category: title, own: true, gold: i === 0 };
    }));

    var card = el('div', 'mtl-quiz__card');
    var hero = el('a', 'mtl-quiz__hero');
    hero.href = url;
    if (heroSrc) {
      var img = el('img');
      img.src = sized(heroSrc, 1200);
      img.alt = title;
      img.loading = 'lazy';
      hero.appendChild(img);
    }
    hero.appendChild(el('span', 'mtl-quiz__hero-cap', title));
    card.appendChild(hero);

    var ownFields = CFG.own_compare && CFG.own_compare.fields_by_collection && CFG.own_compare.fields_by_collection[handle];
    var peek = ownFields ? [] : products.slice(0, CFG.peek_count || 3);
    if (peek.length) {
      var grid = el('div', 'mtl-quiz__peek');
      peek.forEach(function (p) {
        var a = el('a');
        a.href = '/products/' + p.handle;
        var box = el('div', 'mtl-quiz__peek-img');
        var src = p.images && p.images[0] && p.images[0].src;
        if (src) {
          var im = el('img');
          im.src = sized(src, 400);
          im.alt = p.title;
          im.loading = 'lazy';
          box.appendChild(im);
        }
        a.appendChild(box);
        a.appendChild(el('div', 'mtl-quiz__peek-title', p.title));
        var mp = minPrice(p);
        if (isFinite(mp)) a.appendChild(el('div', 'mtl-quiz__peek-price', R.from + ' ' + money(mp)));
        grid.appendChild(a);
      });
      card.appendChild(grid);
    }

    var footer = el('div', 'mtl-quiz__card-foot');
    var cta = el('a', 'mtl-quiz__btn', R.cta.replace('{title}', title));
    cta.href = url;
    footer.appendChild(cta);
    card.appendChild(footer);
    slot.appendChild(card);
    if (ownFields) renderOwnCompare(slot, products, mode, ownFields);
  }

  function renderSecondary(slot, route, data) {
    var R = CFG.results;
    var handle = route.secondary;
    var title = (data.meta && data.meta.title) || handle;
    var mode = sortMode(route, 'secondary');
    var products = sortProducts(data.products, mode);
    var box = el('div', 'mtl-quiz__secondary');
    box.appendChild(el('p', 'mtl-quiz__secondary-label', route.secondary_label || R.secondary_label));
    var a = el('a', 'mtl-quiz__mini');
    a.href = '/collections/' + handle + linkSort(mode);
    var imgBox = el('div', 'mtl-quiz__mini-img');
    var src = (products[0] && products[0].images && products[0].images[0] && products[0].images[0].src) || (data.meta && data.meta.image && data.meta.image.src);
    if (src) {
      var im = el('img');
      im.src = sized(src, 200);
      im.alt = '';
      im.loading = 'lazy';
      imgBox.appendChild(im);
    }
    a.appendChild(imgBox);
    var txt = el('div');
    txt.appendChild(el('div', 'mtl-quiz__mini-title', title));
    if (products.length && R.secondary_count) {
      txt.appendChild(el('div', 'mtl-quiz__mini-sub', R.secondary_count.replace('{n}', String(products.length))));
    }
    a.appendChild(txt);
    box.appendChild(a);
    slot.appendChild(box);
  }

  /* Outside recommendation for a gap outcome: one highlighted pick for the investment tier, compared on the same
     fields as its nearest cheaper and pricier neighbours. Straight to the product, never a second quiz. */
  function pickReferral(route) {
    var set = CFG.referrals && CFG.referrals.by_outcome && route.outcome && CFG.referrals.by_outcome[route.outcome];
    if (!set || !set.picks || !set.picks.length) return null;
    var tier = pathAnswers().INV;
    if (tier === 'show_fits' && set.neutral && set.neutral.length) {
      var chosen = set.picks.filter(function (p) { return set.neutral.indexOf(p.id) !== -1; });
      return { id: 'neutral', set: set, pick: null, compare: chosen };
    }
    var hl = set.highlight || {};
    var id = hl[tier] || set.picks[0].id;
    var idx = 0;
    set.picks.forEach(function (p, i) { if (p.id === id) idx = i; });
    var n = set.picks.length;
    var start = Math.max(0, Math.min(idx - 1, n - 3));
    return { id: set.picks[idx].id, set: set, pick: set.picks[idx], compare: set.picks.slice(start, start + 3) };
  }

  /* The brand's own published photo, loaded from their site. If it ever fails, the box removes itself
     instead of leaving a broken image. */
  function refImage(p, cls) {
    if (!p.image) return null;
    var box = el('div', cls);
    var im = el('img');
    im.src = p.image;
    im.alt = p.name;
    im.loading = 'lazy';
    im.referrerPolicy = 'no-referrer';
    if (p.image_position) im.style.objectPosition = p.image_position;
    if (p.image_zoom) { im.style.transform = 'scale(' + p.image_zoom + ')'; im.style.transformOrigin = p.image_position || 'center'; }
    im.addEventListener('error', function () { if (box.parentNode) box.parentNode.classList.remove('has-img'); box.remove(); });
    box.appendChild(im);
    return box;
  }

  function visitLink(p, cls, text) {
    var a = el('a', cls, text);
    a.href = p.url;
    if (!p.own) {
      a.target = '_blank';
      a.rel = 'noopener';
    }
    return a;
  }

  function renderReferral(ref) {
    var C = CFG.referrals;
    var set = ref.set;
    var pick = ref.pick || {};
    var box = el('div', 'mtl-quiz__secondary mtl-quiz__referral');
    box.appendChild(el('p', 'mtl-quiz__secondary-label', C.label));
    var intro = ref.pick ? set.intro : (C.neutral_intro || set.intro);
    if (intro) box.appendChild(el('p', 'mtl-quiz__referral-intro', intro));

    var hasTable = ref.compare.length > 1 && set.fields && set.fields.length;
    /* The table already shows every photo, so the big photo only appears when there is no table. */
    var showHero = !hasTable && pick.image;
    if (!hasTable) {
    var a = visitLink(pick, 'mtl-quiz__mini mtl-quiz__referral-link' + (showHero ? ' has-img' : ''));
    var hero = showHero ? refImage(pick, 'mtl-quiz__referral-img') : null;
    if (hero) a.appendChild(hero);
    var txt = el('div', 'mtl-quiz__referral-txt');
    txt.appendChild(el('div', 'mtl-quiz__mini-title', pick.name));
    if (pick.diff) txt.appendChild(el('div', 'mtl-quiz__mini-sub', pick.diff));
    a.appendChild(txt);
    a.appendChild(el('span', 'mtl-quiz__referral-go', 'Visit ' + pick.brand + ' ↗'));
    box.appendChild(a);
    }

    if (hasTable) {
      if (ref.pick) box.appendChild(el('p', 'mtl-quiz__secondary-label mtl-quiz__compare-label', C.compare_label));
      var scroll = el('div', 'mtl-quiz__compare');
      var table = el('table');
      var thead = el('thead');
      var hr = el('tr');
      var corner = el('td', 'mtl-quiz__compare-corner');
      corner.setAttribute('aria-hidden', 'true');
      hr.appendChild(corner);
      ref.compare.forEach(function (p) {
        var th = el('th', p.id === pick.id ? 'is-pick' : null);
        th.setAttribute('scope', 'col');
        if (p.id === pick.id && C.pick_badge) th.appendChild(el('span', 'mtl-quiz__fit-badge', C.pick_badge));
        var link = visitLink(p, 'mtl-quiz__compare-head');
        var thumb = refImage(p, 'mtl-quiz__compare-img');
        if (thumb) link.appendChild(thumb);
        link.appendChild(el('span', 'mtl-quiz__compare-name', p.name));
        th.appendChild(link);
        hr.appendChild(th);
      });
      thead.appendChild(hr);
      table.appendChild(thead);
      var tbody = el('tbody');
      set.fields.forEach(function (f) {
        var tr = el('tr');
        var rh = el('th', null, f.label);
        rh.setAttribute('scope', 'row');
        tr.appendChild(rh);
        ref.compare.forEach(function (p) {
          tr.appendChild(el('td', p.id === pick.id ? 'is-pick' : null, (p.values && p.values[f.key]) || '–'));
        });
        tbody.appendChild(tr);
      });
      table.appendChild(tbody);
      scroll.appendChild(table);
      box.appendChild(scroll);
      var diffs = el('ul', 'mtl-quiz__compare-diffs');
      ref.compare.forEach(function (p) {
        if (!p.diff) return;
        var li = el('li');
        li.appendChild(el('strong', null, p.name + ': '));
        li.appendChild(document.createTextNode(p.diff));
        diffs.appendChild(li);
      });
      if (diffs.childNodes.length) box.appendChild(diffs);
    }

    var disc = [C.disclosure, C.checked_label ? C.checked_label + ' ' + (C.checked_on || C.reviewed_at) + '.' : null].filter(Boolean).join(' ');
    if (disc) box.appendChild(el('p', 'mtl-quiz__referral-disc', disc));
    return box;
  }


  /* MTL's own products compared on the same table as the referrals. The gold column is the product closest to the
     visitor's budget (the first one the tier sort picks); "show me what fits" gets cheapest, middle and top, no gold. */
  function renderOwnCompare(slot, products, mode, fields) {
    var O = CFG.own_compare;
    /* Accessories that sit in a category (a chiller with no tub) never go in a side-by-side of the real thing. */
    products = products.filter(function (p) { return (O.exclude_handles || []).indexOf(p.handle) === -1; });
    var asc = sortProducts(products, 'price-ascending');
    if (asc.length < 2) return;
    var tier = pathAnswers().INV;
    /* Budget decides the gold column, not the route's own sort (some routes force cheapest-first). */
    mode = (tier && CFG.investment_sort[tier]) || 'collection';
    var chosen, pickHandle = null;
    if (tier === 'show_fits' || mode === 'collection') {
      var mid = asc[Math.floor((asc.length - 1) / 2)];
      chosen = [asc[0], mid, asc[asc.length - 1]].filter(function (p, i, a) { return a.indexOf(p) === i; });
    } else {
      var best = sortProducts(products, mode)[0];
      pickHandle = best.handle;
      var idx = asc.indexOf(best);
      var start = Math.max(0, Math.min(idx - 1, asc.length - 3));
      chosen = asc.slice(start, start + 3);
    }
    var holder = el('div', 'mtl-quiz__secondary mtl-quiz__own-compare');
    slot.appendChild(holder);
    Promise.all(chosen.map(function (p) {
      return fetch('/products/' + encodeURIComponent(p.handle) + '?view=compare-json', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (t) { try { return t ? JSON.parse(t) : null; } catch (e) { return null; } })
        .catch(function () { return null; })
        .then(function (d) {
          var values = {};
          values._price = O.from + ' ' + money(minPrice(p));
          var specs = d && d.specs;
          if (specs) Object.keys(specs).forEach(function (k) { values[k] = specs[k]; });
          var img = (d && d.image) || (p.images && p.images[0] && sized(p.images[0].src, 600));
          return { id: p.handle, own: true, name: (O.short_names && O.short_names[p.handle]) || shortName((d && d.title) || p.title, p.vendor), url: '/products/' + p.handle, image: img, diff: d && d.diff, values: values };
        });
    })).then(function (items) {
      /* Drop a row when none of the three products states it: a row of dashes tells the visitor nothing. */
      var rows = [{ key: '_price', label: O.price_label }].concat(fields).filter(function (f) {
        return items.some(function (p) { var v = p.values && p.values[f.key]; return v && v !== '–' && v !== '-'; });
      });
      holder.appendChild(el('p', 'mtl-quiz__secondary-label mtl-quiz__compare-label', O.label));
      if (!pickHandle && O.neutral_intro) holder.appendChild(el('p', 'mtl-quiz__referral-intro', O.neutral_intro));
      holder.appendChild(compareTable(items, rows, pickHandle));
      var diffs = el('ul', 'mtl-quiz__compare-diffs');
      items.forEach(function (p) {
        if (!p.diff) return;
        var li = el('li');
        li.appendChild(el('strong', null, p.name + ': '));
        li.appendChild(document.createTextNode(p.diff));
        diffs.appendChild(li);
      });
      if (diffs.childNodes.length) holder.appendChild(diffs);
    });
  }

  /* Every column in a category is usually one brand, so the brand prefix is noise in a narrow column. */
  function shortName(title, vendor) {
    if (vendor && title.indexOf(vendor + ' ') === 0) {
      var rest = title.slice(vendor.length + 1);
      if (rest.indexOf(' ') !== -1) return rest;
    }
    return title;
  }

  function compareTable(items, rows, pickId) {
    var badge = CFG.referrals && CFG.referrals.pick_badge;
    var scroll = el('div', 'mtl-quiz__compare');
    var table = el('table');
    var thead = el('thead');
    var hr = el('tr');
    var corner = el('td', 'mtl-quiz__compare-corner');
    corner.setAttribute('aria-hidden', 'true');
    hr.appendChild(corner);
    items.forEach(function (p) {
      var th = el('th', p.id === pickId ? 'is-pick' : null);
      th.setAttribute('scope', 'col');
      if (p.id === pickId && badge) th.appendChild(el('span', 'mtl-quiz__fit-badge', badge));
      var link = visitLink(p, 'mtl-quiz__compare-head');
      var thumb = refImage(p, 'mtl-quiz__compare-img');
      if (thumb) link.appendChild(thumb);
      link.appendChild(el('span', 'mtl-quiz__compare-name', p.name));
      th.appendChild(link);
      hr.appendChild(th);
    });
    thead.appendChild(hr);
    table.appendChild(thead);
    var tbody = el('tbody');
    rows.forEach(function (f) {
      var tr = el('tr');
      var rh = el('th', null, f.label);
      rh.setAttribute('scope', 'row');
      tr.appendChild(rh);
      items.forEach(function (p) {
        tr.appendChild(el('td', p.id === pickId ? 'is-pick' : null, (p.values && p.values[f.key]) || '\u2013'));
      });
      tbody.appendChild(tr);
    });
    table.appendChild(tbody);
    scroll.appendChild(table);
    return scroll;
  }


  /* ---------- cross-category engine (problem first) ---------- */
  function engineRules() {
    var E = CFG.engine, P = E && E.pillar_rules && E.pillar_rules[state.pillar];
    if (!P) return null;
    var a = pathAnswers();
    if (P.scope_bases) return P.scope_bases[a[P.scope_key]] || (a[P.goal_key] ? P.scope_bases.full : null) ? P : null;
    return P.goals && P.goals[a[P.goal_key]] ? P : null;
  }

  function engineAllowsGap(P) {
    return !!(P && P.gap_goals && P.gap_goals.indexOf(pathAnswers()[P.goal_key]) !== -1);
  }

  function engineReplacesReferral(P) {
    return !!(P && P.replaces_referral && P.replaces_referral.indexOf(pathAnswers()[P.goal_key]) !== -1);
  }

  function enginePlan(P) {
    var E = CFG.engine, a = pathAnswers(), weights = {};
    var add = function (src) { Object.keys(src || {}).forEach(function (c) { weights[c] = (weights[c] || 0) + src[c]; }); };
    if (P.scope_bases) {
      var scope = a[P.scope_key] || 'full';
      add(P.scope_bases[scope]);
      add((P.goal_adjust || {})[a[P.goal_key]]);
      if (scope === 'targeted') { Object.keys(weights).forEach(function (c) { if (['compression', 'light', 'massage'].indexOf(c) === -1) delete weights[c]; }); }
      var hc = a[P.heat_cold_key];
      if (hc === 'heat') { delete weights.cold; ['sauna', 'soak'].forEach(function (c) { if (weights[c]) weights[c] += 1; }); }
      /* Leaning cold: heat stays available but drops to the back, so it never takes gold from a cold-friendly pick. */
      if (hc === 'cold') { weights.cold = (weights.cold || 1) + 2; ['sauna', 'soak'].forEach(function (c) { if (weights[c]) weights[c] = 1; }); }
      if (hc === 'both' && !weights.cold) weights.cold = 1;
      var g = P.float_gate;
      if (!g || !(a[P.goal_key] === g.goal && a[P.space_key] === g.space && a.INV === g.tier)) delete weights.float;
    } else {
      add(P.goals[a[P.goal_key]]);
    }
    Object.keys(weights).forEach(function (c) { if (weights[c] <= 0 || !E.categories[c]) delete weights[c]; });
    return { weights: weights, a: a, scope: P.scope_bases ? (a[P.scope_key] || 'full') : null };
  }

  function budgetDistance(p, mode) {
    var pr = minPrice(p);
    if (mode.indexOf('center:') === 0) return Math.abs(pr - parseFloat(mode.split(':')[1]));
    if (mode === 'price-descending') return -pr;
    return pr;
  }

  function answerHash() {
    var str = JSON.stringify(pathAnswers()), h = 0;
    for (var i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
    return h;
  }

  function engineEligible(handle, P, plan) {
    var t = CFG.engine.tags[handle], a = plan.a;
    if (!t) return false;
    if ((CFG.exclude_handles || []).indexOf(handle) !== -1) return false;
    if (((CFG.own_compare || {}).exclude_handles || []).indexOf(handle) !== -1) return false;
    /* Goal-specific exclusions (the Lagree Sculptformer is strength work, not a mobility or everyday pick). */
    if (((P.goal_excludes || {})[a[P.goal_key]] || []).indexOf(handle) !== -1) return false;
    if (P.space_key && a[P.space_key] === P.limited_value && !t.portable) return false;
    if (P.place_filter && P.place_filter.indexOf(t.place) === -1) return false;
    if (t.scope && plan.scope === 'targeted' && t.scope !== 'targeted') return false;
    if (t.cat === 'light' && plan.scope === 'full' && t.scope === 'targeted') return false;
    var pl = P.place_key ? a[P.place_key] : null;
    if (pl === 'inside' && t.place === 'outdoor') return false;
    if ((pl === 'outside_cold' || pl === 'outside_mild') && t.place === 'indoor') return false;
    if (pl === 'outside_cold' && t.cold_ok === false) return false;
    return true;
  }

  function renderEngine(slot, P) {
    var E = CFG.engine, plan = enginePlan(P), a = plan.a;
    var tier = a.INV;
    var floorOf = (P.tier_floor || {});
    var cats = Object.keys(plan.weights).filter(function (c) {
      var mb = E.categories[c].min_budget;
      if (!mb || tier === 'show_fits' || floorOf[tier] == null) return true;
      return floorOf[tier] >= mb;
    });
    var mode = (tier && CFG.investment_sort[tier]) || 'collection';
    var neutral = tier === 'show_fits' || mode === 'collection';
    var center = mode.indexOf('center:') === 0 ? parseFloat(mode.split(':')[1]) : null;
    Promise.all(cats.map(function (c) {
      var C0 = E.categories[c];
      if (C0.external) {
        var its = (C0.items || []).slice();
        if (!its.length) return Promise.resolve(null);
        var byP = function (m) { var arr = its.slice(); if (m === 'price-descending') arr.sort(function (x, y) { return y.price_num - x.price_num; }); else if (m.indexOf('center:') === 0) { var cc = parseFloat(m.split(':')[1]); arr.sort(function (x, y) { return Math.abs(x.price_num - cc) - Math.abs(y.price_num - cc); }); } else arr.sort(function (x, y) { return x.price_num - y.price_num; }); return arr; };
        var ordX = neutral ? byP('price-ascending') : byP((P.pick_modes || {})[a[P.goal_key]] === 'approachable' ? 'price-ascending' : mode);
        var it = neutral ? ordX[Math.floor((ordX.length - 1) / 2)] : ordX[0];
        var bandX = (P.bands || {})[tier];
        return Promise.resolve({ cat: c, external: true, ext: it, extOrdered: ordX, product: { handle: it.ref_id }, price: it.price_num, score: plan.weights[c],
          fit: center != null ? Math.abs(it.price_num - center) : (mode === 'price-ascending' ? it.price_num : -it.price_num), inBand: !bandX || it.price_num < bandX[1], ordered: [] });
      }
      return fetchCollection(C0.collection).then(function (data) {
        var pool = data.products.filter(function (p) { return engineEligible(p.handle, P, plan); });
        if (!pool.length) return null;
        var pick, ordered;
        if (neutral) { var asc = sortProducts(pool, 'price-ascending'); pick = asc[Math.floor((asc.length - 1) / 2)]; ordered = asc; }
        else if ((P.pick_modes || {})[a[P.goal_key]] === 'approachable') { ordered = sortProducts(pool, 'price-ascending'); pick = ordered[0]; }
        else {
          ordered = sortProducts(pool, mode);
          /* Answer fit before budget: outside with cold winters prefers models the page rates for it. */
          if (P.place_key && a[P.place_key] === 'outside_cold') ordered.sort(function (x, y) { return ((E.tags[y.handle] || {}).cold_ok === true ? 1 : 0) - ((E.tags[x.handle] || {}).cold_ok === true ? 1 : 0); });
          /* Variety comes last: rotate among options that fit about equally well (within 10 percent on budget). */
          var bestD = budgetDistance(ordered[0], mode);
          var close = ordered.filter(function (p) { return budgetDistance(p, mode) <= bestD + Math.max(250, 0.1 * (minPrice(ordered[0]) || 1)) && ((E.tags[p.handle] || {}).cold_ok === (E.tags[ordered[0].handle] || {}).cold_ok); });
          if (close.length > 1) { var pickV = close[answerHash() % close.length]; ordered = [pickV].concat(ordered.filter(function (p) { return p !== pickV; })); }
          pick = ordered[0];
        }
        var price = minPrice(pick);
        var fit = center != null ? Math.abs(price - center) : (mode === 'price-ascending' ? price : -price);
        var band = (P.bands || {})[tier];
        /* Coming in under budget is fine; only going over their range rules out the gold badge. */
        var inBand = !band || price < band[1];
        return { cat: c, product: pick, price: price, score: plan.weights[c], fit: fit, inBand: inBand, ordered: ordered };
      });
    })).then(function (rows) {
      rows = rows.filter(Boolean);
      if (!rows.length) return;
      /* In-budget options lead; an over- or under-budget category can still appear, it just never leads. */
      rows.sort(function (x, y) { return ((y.inBand ? 1 : 0) - (x.inBand ? 1 : 0)) || (y.score - x.score) || (x.fit - y.fit); });
      var top = rows.slice(0, 3);
      /* The category that fits their problem best always gets a column, even over budget (it just can't be gold). */
      var best = rows.slice().sort(function (x, y) { return (y.score - x.score) || (x.fit - y.fit); })[0];
      if (top.indexOf(best) === -1) { if (top.length < 3) top.push(best); else top[2] = best; }
      if (P.heat_cold_key && a[P.heat_cold_key] === 'both') {
        var locked = [best];
        var swap = function (want) {
          var r = rows.filter(want).filter(function (x) { return top.indexOf(x) === -1; })[0];
          if (!r) return;
          if (top.length < 3) { top.push(r); locked.push(r); return; }
          for (var i = top.length - 1; i >= 0; i--) { if (locked.indexOf(top[i]) === -1) { top[i] = r; locked.push(r); return; } }
        };
        if (!top.some(function (r) { return r.cat === 'cold'; })) swap(function (r) { return r.cat === 'cold'; });
        if (!top.some(function (r) { return E.categories[r.cat].temp === 'heat'; })) swap(function (r) { return E.categories[r.cat].temp === 'heat'; });
      }
      /* Fewer than three categories qualify: fill from the strongest category so there are still three real options. */
      if (top.length < 3) {
        var used = top.map(function (r) { return r.product.handle; });
        var bandF = (P.bands || {})[tier];
        /* Where a pillar names a category to fill from (sleep: competitor mattresses), it fills first. */
        rows.slice().sort(function (x, y) { return ((y.cat === P.fill_prefer ? 1 : 0) - (x.cat === P.fill_prefer ? 1 : 0)) || (y.score - x.score); }).forEach(function (r) {
          (r.ordered || []).forEach(function (p) {
            if (top.length >= 3 || used.indexOf(p.handle) !== -1) return;
            used.push(p.handle);
            var pr = minPrice(p);
            top.push({ cat: r.cat, product: p, price: pr, score: r.score, fit: 0, inBand: !bandF || pr < bandF[1] });
          });
          (r.extOrdered || []).forEach(function (it2) {
            if (top.length >= 3 || used.indexOf(it2.ref_id) !== -1) return;
            used.push(it2.ref_id);
            top.push({ cat: r.cat, external: true, ext: it2, product: { handle: it2.ref_id }, price: it2.price_num, score: r.score, fit: 0, inBand: !bandF || it2.price_num < bandF[1] });
          });
        });
      }
      if (neutral) top.sort(function (x, y) { return x.price - y.price; });
      /* The gold badge says "Fits your budget and goals", so it only goes to an in-budget pick. */
      var goldRow = neutral ? null : top.filter(function (r) { return r.inBand; })[0];
      var pickHandle = goldRow ? goldRow.product.handle : null;
      return Promise.all(top.map(function (r) {
        if (r.external) {
          var set = (CFG.referrals.by_outcome || {})[r.ext.ref_outcome || E.categories[r.cat].ref_outcome] || {};
          var rp = (set.picks || []).filter(function (x) { return x.id === r.ext.ref_id; })[0] || {};
          return Promise.resolve({ id: rp.id, own: false, external: true, cat: r.cat, name: rp.name, url: rp.url, image: rp.image,
            image_position: rp.image_position, image_zoom: rp.image_zoom, diff: rp.diff,
            values: Object.assign({}, rp.values || {}, { _price: r.ext.price_label || ((CFG.own_compare || {}).from || 'From') + ' ' + money(r.ext.price_num),
              _type: E.categories[r.cat].label, _good: E.categories[r.cat].good_for, temp: (rp.values || {}).cooling || (rp.values || {}).temp,
              size: r.ext.size || (rp.values || {}).space || (rp.values || {}).size,
              _portable: r.ext.portable === false ? E.portable_labels.no : (r.ext.portable === true ? E.portable_labels.yes : '\u2013') }) });
        }
        var p = r.product, t = E.tags[p.handle];
        return fetch('/products/' + encodeURIComponent(p.handle) + '?view=compare-json', { credentials: 'same-origin' })
          .then(function (res) { return res.ok ? res.text() : null; })
          .then(function (txt) { try { return txt ? JSON.parse(txt) : null; } catch (e) { return null; } })
          .catch(function () { return null; })
          .then(function (d) {
            var O = CFG.own_compare || {};
            return { id: p.handle, own: true, cat: r.cat,
              name: (O.short_names && O.short_names[p.handle]) || shortName((d && d.title) || p.title, p.vendor),
              url: '/products/' + p.handle,
              image: (d && d.image) || (p.images && p.images[0] && sized(p.images[0].src, 600)),
              diff: d && d.diff,
              values: Object.assign({}, (d && d.specs) || {}, { _price: (O.from || 'From') + ' ' + money(r.price), _type: E.categories[r.cat].label, temp: t.temp, size: t.size,
                _place: E.place_labels[t.place] || t.place, power: t.power, _good: E.categories[r.cat].good_for || '\u2013', _portable: t.portable === true ? E.portable_labels.yes : (t.portable === false ? E.portable_labels.no : '–') }) };
          });
      })).then(function (items) {
        trackResults(items.map(function (p, i) {
          return { name: p.name, url: p.url, image: p.image, price: p.values._price, price_num: top[i].price,
            category: E.categories[p.cat].label, own: p.own, gold: p.id === pickHandle, why: p.diff };
        }));
        var box = el('div', 'mtl-quiz__secondary mtl-quiz__own-compare mtl-quiz__engine');
        var rowsF = P.fields.filter(function (f) {
          return items.some(function (p) { var v = p.values[f.key]; return v && v !== '\u2013' && v !== 'Neither'; });
        });
        box.appendChild(compareTable(items, rowsF, pickHandle));
        var diffs = el('ul', 'mtl-quiz__compare-diffs');
        items.forEach(function (p) {
          if (!p.diff) return;
          var li = el('li');
          li.appendChild(el('strong', null, p.name + ': '));
          li.appendChild(document.createTextNode(p.diff));
          diffs.appendChild(li);
        });
        if (diffs.childNodes.length) box.appendChild(diffs);
        box.appendChild(el('p', 'mtl-quiz__secondary-label mtl-quiz__compare-label', E.explore_label));
        var links = el('ul', 'mtl-quiz__engine-links');
        var seen = {};
        items.forEach(function (p) {
          var c = E.categories[p.cat];
          if (c.external || seen[c.collection]) return;
          seen[c.collection] = true;
          var li = el('li');
          var lk = el('a', null, E.explore_link.replace('{plural}', c.plural) + ' \u2192');
          lk.href = '/collections/' + c.collection;
          li.appendChild(lk);
          links.appendChild(li);
        });
        box.appendChild(links);
        if (items.some(function (p) { return p.external; }) && CFG.referrals && CFG.referrals.disclosure) {
          box.appendChild(el('p', 'mtl-quiz__referral-disc', CFG.referrals.disclosure));
        }
        slot.appendChild(box);
      });
    });
  }

  /* Honest edge notes from the logic docs: never hard-exclude, say so when the band has nothing. */
  function edgeNote(products) {
    if (!products.length) return null;
    var tier = pathAnswers().INV;
    var prices = products.map(minPrice).filter(isFinite);
    if (!prices.length) return null;
    var edge = (CFG.investment_edges || {})[tier];
    if (!edge) return null;
    if (edge.below && Math.min.apply(null, prices) > edge.below) return CFG.results.note_above_range;
    if (edge.top && Math.max.apply(null, prices) < edge.top) return CFG.results.note_top_of_range;
    return null;
  }

  /* ---------- boot ---------- */
  backBtn.addEventListener('click', goBack);

  if (params.get('quiz_reset') === '1') {
    sDel('sessionStorage', STATE_KEY);
    if (forceGate) sDel('localStorage', CAPTURED_KEY);
  }
  /* Strip the one-shot test params from the address bar. The gate's form post returns the visitor to this
     URL, and a surviving quiz_reset=1 would wipe their saved answers and drop them back on question one. */
  if (params.has('quiz_reset') || params.has('customer_posted')) {
    try {
      var clean = new URL(window.location.href);
      clean.searchParams.delete('quiz_reset');
      clean.searchParams.delete('customer_posted');
      window.history.replaceState(null, '', clean.pathname + (clean.search || '') + clean.hash);
    } catch (e) {}
  }
  var resumed = load();
  if (resumed) state = resumed;
  var postedEl = root.querySelector('[data-quiz-posted]');
  if (postedEl && state.stage === 'gate_submitted') {
    var gateResult = postedEl.getAttribute('data-quiz-posted') === 'true' ? 'accepted' : ('not-accepted: ' + (postedEl.getAttribute('data-quiz-errors') || 'no error text'));
    sSet('sessionStorage', 'mtl_quiz_gate_result', gateResult);
  }
  if (state.stage === 'results' || state.stage === 'gate_submitted') showResults();
  else renderScreen(state.screen || 'Q0');
})();
